export const ITEM_CATEGORY = Object.freeze({
  CONSUMABLE:  "CONSUMABLE",
  MATERIAL:    "MATERIAL",
  TOOLS:       "TOOLS",
  ASSET:       "ASSET",
});

export const MRF_ALLOWED_CATEGORIES = Object.freeze([
  // ✅ Sirf yeh 2 — Item Master mein bhi sirf yahi hain
  ITEM_CATEGORY.CONSUMABLE,  // "CONSUMABLE"
  ITEM_CATEGORY.MATERIAL,    // "MATERIAL"
  // ✅ Legacy support — purane items jo custom categories mein hain
  // Fix General Categories button chalane ke baad yeh khatam ho jaayenge
  "GENERAL",
  "COPPER",
  "ELECTRICAL",
  "REFRIGERANT",
  "DUCTING",
  "HARDWARE",
  "CONSUMABLES",
  "SPARES",
  "SAFETY",
  "TESTING",
  "VRF/VRV",
  "CHILLER",
  "SPLIT AC",
]);

export const ASSET_ENGINE_CATEGORIES = Object.freeze([
  ITEM_CATEGORY.TOOLS,
  ITEM_CATEGORY.ASSET,
]);

export const isMRFCategory = (category) => {
  return MRF_ALLOWED_CATEGORIES.includes(
    String(category || "").trim().toUpperCase()
  );
};

export const isAssetEngineCategory = (category) => {
  return ASSET_ENGINE_CATEGORIES.includes(
    String(category || "").trim().toUpperCase()
  );
};